import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export const resendPaymentRequest = async (
  paymentRequestId: string
) => {
  await api.post(
    `/beepaidgo/payment-requests/${paymentRequestId}/resend/`
  )

  queryClient.invalidateQueries([
    PAYMENT_REQUESTS_QUERY_KEY,
  ])
}
